import { render, staticRenderFns } from "./Char.vue?vue&type=template&id=325a7ab2&"
import script from "./Char.vue?vue&type=script&lang=js&"
export * from "./Char.vue?vue&type=script&lang=js&"
import style0 from "./Char.vue?vue&type=style&index=0&id=325a7ab2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports